import * as React from "react";
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import CardHeader from "@mui/material/CardHeader";
import classes from "../Styles/ReadyToSellByCarrier.module.css";

const RTSByCarrierTotalCard = (props) => {
  const { id, agencyReadyToSellByCarrier } = props;
  // const getFillColor = (carrierName) => {
  //   const colorMap = {
  //     "Aetna US Health Care": "#F90101",
  //     "Cigna MA/PDP": "#56B4E9",
  //     "Elevance/Anthem": "#F07900",
  //     Humana: "#39C05E",
  //     UHC: "#0072B2",
  //     WellCare: "#CC79A7",
  //     "Aetna MS": "#9F05C5",
  //     SCAN: "#D55E00",
  //     Molina: "#A9A19F",
  //     ATRIO: "#FFE134",
  //     "UHC IFP": "#7E1215",
  //     "FL Blue": "#2C73E9",
  //     "Devoted Health": "#062A77",
  //     "ACE Medicare Supplements": "#A27900",
  //     "LA Care": "#A2C8EC",
  //   };

  //   return colorMap[carrierName] || "#000000";
  // };

  const filteredData = agencyReadyToSellByCarrier.filter(
    (records) => records.carrierId === id
  );
  const getCount = () => {
    let results = 0;
    filteredData.forEach((item) => {
      results += parseInt(item.totalByReadyStatus);
    });
    return results;
  };

  const getName = () => {
    return filteredData[0]?.carrierName;
  };
  const name = getName();
  const count = getCount();

  return (
    <Box sx={{ minWidth: 275, margin: 1 }}>
      <Card className={classes.gridItem} sx={{ maxWidth: 225 }}>
        <CardHeader
          //title={<span style={{ color: getFillColor(name) }}>{name}</span>}
          title={<span>{name}</span>}
          subheader={`Total: ${count}`}
        />
      </Card>
    </Box>
  );
};

export default RTSByCarrierTotalCard;
